export var creaMasonry = function (selector) {
    return new Masonry(selector);
};
var Masonry = /** @class */ (function () {
    function Masonry(selector) {
        var _this = this;
        this.selector = selector;
        this.elementos = [];
        this.total = 0;
        this.buscaElementos = function () {
            var hijos = [].slice.call(_this.galeria.childNodes);
            _this.elementos = hijos.filter(function (hijo) { return hijo.nodeName !== '#text'; });
            _this.total = _this.elementos.length;
        };
        this.inicializa = function () {
            _this.galeria.style.position = 'relative';
            _this.buscaElementos();
            _this.activo = true;
            var imagenes = [].slice.call(document.querySelectorAll("".concat(_this.selector, " img:not(.cargada)")));
            imagenes.forEach(function (img) {
                img.addEventListener('load', function () {
                    img.classList.add('cargada');
                    _this.actualiza();
                });
            });
            var timeout = undefined;
            window.addEventListener('resize', function () {
                clearTimeout(timeout);
                timeout = window.setTimeout(function () { return requestAnimationFrame(_this.actualizaInterno); }, 100);
            });
            window.addEventListener('load', _this.actualizaInterno);
            requestAnimationFrame(_this.ajustaAltura);
        };
        this.ajustaAltura = function () {
            var altoMaximo = _this.elementos.reduce(function (acc, el) {
                return Math.max(acc, el.getBoundingClientRect().bottom);
            }, 0);
            _this.galeria.style.height =
                altoMaximo - _this.galeria.getBoundingClientRect().top + 'px';
            requestAnimationFrame(_this.ajustaAltura);
        };
        this.actualiza = function () {
            _this.buscaElementos();
            _this.actualizaInterno();
        };
        this.actualizaInterno = function () {
            if (!_this.activo) {
                return;
            }
            _this.elementos.forEach(function (el) {
                el.style.position = 'static';
                el.style.top = String(0);
                el.style.left = String(0);
                el.style.width = 'auto';
            });
            var gapVertical = parseFloat(getComputedStyle(_this.galeria).gridRowGap), gapHorizontal = parseFloat(getComputedStyle(_this.galeria).gridColumnGap), columnas = Math.round(_this.galeria.offsetWidth / _this.elementos[0].offsetWidth), filas = Math.ceil(_this.total / columnas);
            if (filas > 1 && columnas > 1) {
                var alturas_1 = _this.elementos.slice(0, columnas).map(function (x) { return x.offsetTop; });
                _this.elementos.forEach(function (elemento, i) {
                    var alturaMinima = alturas_1.reduce(function (min, h) { return Math.min(min, h); }), posicion = alturas_1.indexOf(alturaMinima), fila = Math.floor(i / columnas), contenido = elemento.firstElementChild, gapHorizontalDeElemento = gapHorizontal * posicion, gapVerticalDeElemento = fila * gapVertical;
                    elemento.style.width = elemento.offsetWidth + 'px';
                    elemento.style.top = alturaMinima + gapVerticalDeElemento + 'px';
                    elemento.style.left = posicion * elemento.offsetWidth + gapHorizontalDeElemento + 'px';
                    alturas_1[posicion] += contenido.offsetHeight + gapHorizontal;
                });
                _this.elementos.forEach(function (el) { return el.style.position = 'absolute'; });
            }
            else {
                _this.galeria.style.height = 'auto';
            }
        };
        var galeria = document.querySelector(selector);
        if (galeria instanceof HTMLElement) {
            this.galeria = galeria;
        }
        else {
            throw Error("No se encontró la galería");
        }
        this.activo = false;
    }
    return Masonry;
}());
